<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-6">
        <list-subject-types
          class="w-100"
          autocomplete
          label="Destinos"
          name="subjectType"
          :isClearable="false"
          v-model="subjectForm.subjectType"
          v-validate="'required'"
          :danger="errors.has('inputDoc.subjectType')"
          :danger-text="errors.first('inputDoc.subjectType')"
          ref="subjectType"
        />
      </div>
      <div class="col-md-6" v-if="subjectForm.subjectType === 'docDigital'">
        <list-institutions-doc-digital
          class="w-100"
          autocomplete
          :isClearable="false"
          label="Lista de Instituciones DocDigital"
          name="subjectTypeDigitalDoc"
          v-model="subjectForm.subjectTypeDigitalDoc"
          :parent-value="subjectForm.subject"
          v-validate="{ required: subjectForm.subjectType === 'docDigital'}"
          :danger="errors.has('inputDoc.subjectTypeDigitalDoc')"
          :danger-text="errors.first('inputDoc.subjectTypeDigitalDoc')"
          ref="subjectTypeDigitalDoc"
          data-cy="subjectTypeDigitalDoc"
          @full-input="setSubject"
        />
      </div>
      <div :class="{
        'col-12': subjectForm.subjectType === 'docDigital',
        'col-md-6': subjectForm.subjectType !== 'docDigital',
      }">
        <list-offices
          v-if="
            !isInput.includes(subjectForm.subjectType)
              && subjectForm.subjectType === 'oficinas'
          "
          class="w-100"
          autocomplete
          label="Oficina"
          name="subject"
          v-model="subjectForm.subject"
          :danger="errors.has('inputDoc.subject')"
          :danger-text="errors.first('inputDoc.subject')"
          v-validate="{ required:  !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType === 'oficinas' }"
          ref="subject"
          key="subject-select"
        />
        <list-groups
          v-if="
            !isInput.includes(subjectForm.subjectType)
                && (subjectForm.subjectType === 'unidades'
                || subjectForm.subjectType === 'comisiones')
          "
          class="w-100"
          autocomplete
          :label="subjectForm.subjectType === 'unidades' ? 'Unidad' : 'Comisión'"
          :showOnlyCommissions="subjectForm.subjectType === 'comisiones'"
          :showOnlyUnits="subjectForm.subjectType === 'unidades'"
          name="subject"
          :typeList="1"
          v-model="subjectForm.subject"
          :danger="errors.has('inputDoc.subject')"
          :danger-text="errors.first('inputDoc.subject')"
          v-validate="{ required:  !isInput.includes(subjectForm.subjectType)
            && (subjectForm.subjectType === 'unidades'
            || subjectForm.subjectType === 'comisiones') }"
          ref="subject"
          key="subject-select"
        />
        <list-subjects
          v-if="
              !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType !== 'usuarios'
                && subjectForm.subjectType !== 'oficinas'
                && subjectForm.subjectType !== 'unidades'
                && subjectForm.subjectType !== 'comisiones'
            "
          class="w-100"
          :isClearable="false"
          autocomplete
          label="Lista de Destino"
          name="subject"
          v-model="subjectForm.subject"
          :parent-value="subjectForm.subjectType"
          v-validate="{
              required: !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType !== 'usuarios'
            }"
          :disabled="!subjectForm.subjectType || this.institutionsDocDigitalState.loading"
          :danger="errors.has('inputDoc.subject')"
          :danger-text="errors.first('inputDoc.subject')"
          ref="subject"
          key="subject-select"
          @input="clearEntities"
        />
        <list-user
          v-if="
              !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType === 'usuarios'
            "
          class="w-100"
          withFilters
          autocomplete
          label="Lista de Destino"
          name="subject"
          v-model="subjectForm.subject"
          v-validate="{
              required: !isInput.includes(subjectForm.subjectType)
                && subjectForm.subjectType === 'usuarios'
            }"
          :disabled="!subjectForm.subjectType"
          :danger="errors.has('inputDoc.subject')"
          :danger-text="errors.first('inputDoc.subject')"
          ref="subject"
          key="subject-select"
        />
        <vs-input
          v-if="isInput.includes(subjectForm.subjectType)"
          class="w-100"
          label="Ingrese un nombre"
          name="subject"
          v-model="subjectForm.subject"
          v-validate="{ required: isInput.includes(subjectForm.subjectType) }"
          :danger="errors.has('inputDoc.subject')"
          :danger-text="errors.first('inputDoc.subject')"
          key="subject-input"
        />
      </div>
    </div>
    <div class="row mb-3" v-if="emailRequired.includes(subjectForm.subjectType)">
      <div class="col-12">
        <vs-input
          class="w-100"
          label="Correo Electrónico Persona Destinatario"
          name="subjectEmail"
          v-model="subjectForm.subjectEmail"
          v-validate="{
              required: emailRequired.includes(subjectForm.subjectType)
              ,
              email: true
            }"
          :danger="errors.has('inputDoc.subjectEmail')"
          :danger-text="errors.first('inputDoc.subjectEmail')"
        />
      </div>
    </div>
    <div class="row mb-3" v-if="subjectForm.subjectType === 'usuarios'">
      <div class="col-6">
        <vs-select
          autocomplete
          class="w-100 con-select autocompletex"
          label="Seleccione tipo de trámite"
          v-model="subjectForm.providence"
        >
          <vs-select-item
            :value="providenceTypes.KNOWLEDGE"
            text="Conocimiento"
          />
          <vs-select-item
            :value="providenceTypes.MANAGEMENT"
            text="Para gestión"
          />
        </vs-select>
      </div>
      <div class="col-6">
        <label>Fecha Vencimiento</label>
        <b-form-datepicker
          locale="es"
          :min="minDate"
          placeholder="Fecha vencimiento"
          name="providenceExpiration"
          v-model="subjectForm.providenceExpiration"
          label-help="Puede usar las flechas del teclado y espacio"
        />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12 d-flex align-items-end justify-content-end">
        <b-button
          data-cy="add-recipient-button"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          v-on:click="addSubject()"
        >
          Agregar Destinatario
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>

import Ripple from 'vue-ripple-directive';
import { mapGetters } from 'vuex';

import ListSubjects from '@/febos/chile/lists/components/ListSubjects';
import ListInstitutionsDocDigital from '@/febos/chile/lists/components/ListInstitutionsDocDigital';
import ListSubjectTypes from '@/febos/chile/lists/components/ListSubjectTypes';
import ListUser from '@/febos/chile/lists/components/ListUser';
import ListOffices from '@/febos/chile/lists/components/ListOffices';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ProvidencesTypes from '@/febos/chile/dnt/mixins/ProvidencesTypes';

export default {
  components: {
    ListSubjects,
    ListSubjectTypes,
    ListInstitutionsDocDigital,
    ListUser,
    ListOffices,
    ListGroups
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      minDate: this.$moment().format('YYYY-MM-DD'),
      providenceTypes: ProvidencesTypes,
      emailRequired: ['personas', 'empresas', 'ministerios', 'personasJuridicas', 'organismoEstado'],
      isInput: ['personas', 'empresas', 'personasJuridicas', 'organismoEstado'],
      subjectForm: {
        subjectType: '',
        providence: '',
        providenceExpiration: '',
        subject: '',
        subjectTypeDigitalDoc: '',
        subjectEmail: '',
      },
      copySubjectForm: {
        copySubjectType: '',
        providence: '',
        providenceExpiration: '',
        copySubject: '',
        copySubjectTypeDigitalDoc: '',
        copySubjectEmail: '',
      },
      subjectsSelected: []
    };
  },
  computed: {
    ...mapGetters('Dnts', [
      'participants'
    ]),
    ...mapGetters('List', [
      'institutionsDocDigitalState'
    ]),
  },
  methods: {
    clearEntities() {
      if (this.subjectForm.subjectTypeDigitalDoc) {
        this.subjectForm.subjectTypeDigitalDoc = '';
      }
    },
    setSubject(event) {
      this.subjectForm.subject = event?.order.toString() || '';
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async addSubject() {
      const isValid = await this.validateForm('inputDoc');

      if (!isValid) {
        return;
      }

      const subjectType = this.$refs.subjectType.getOption();
      const subject = this.isInput.includes(this.subjectForm.subjectType)
        ? {
          label: this.subjectForm.subject,
          value: this.subjectForm.subject,
          id: this.subjectForm.subject
        }
        : this.$refs.subject.getOption();

      const subjectTypeDigitalDoc = this.$refs.subjectTypeDigitalDoc
        ? this.$refs.subjectTypeDigitalDoc.getOption()
        : {};

      const row = {
        subjectType,
        subject,
        subjectTypeDigitalDoc,
        subjectEmail: this.subjectForm.subjectEmail,
        providence: this.subjectForm.providence,
        providenceExpiration: this.subjectForm.providenceExpiration
      };
      this.$emit('add-subject', row);
      this.subjectForm.subject = '';
      this.subjectForm.providenceExpiration = '';
      this.subjectForm.providence = '';
      this.subjectForm.subjectTypeDigitalDoc = '';
      this.subjectForm.subjectEmail = '';
      await this.$validator.reset();
    }
  }
};
</script>
<style>

</style>
